import React, { useState } from "react";
import { Modal } from "antd";
import Form, { FormInputComponent } from "../../../components/form/Form";
import { Input } from "formsy-react-components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import TalentCandidate from "../../../models/TalentCandidate";
import { useAuth } from "../../../providers/AuthProvider";
import TalentPool from "../../../models/TalentPool";

const LOOKUP = {
    "favorites": -1,
    "past-hires": -2,
    "bring-your-own-talent": -3,
}
const InviteByEmailModal = ({useDarkTheme,...props}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formModel, setFormModel] = useState({});
    const { auth } = useAuth();
    const queryClient = useQueryClient();

    const inviteByEmailMutation = useMutation(
        ['inviteByEmailMutation'],
        formModel => TalentCandidate.inviteByEmail(auth.clientOrg?.()?.id, formModel),
        {
            onSuccess: async (e) => {
                // update talent pool quantities after invite
                queryClient.setQueryData(['fetchTalentPools', {clientId: auth.clientOrg?.()?.id}], oldData => {
                    if (!oldData|| !TB.isArray(oldData)) return oldData;

                    return oldData.map(pool => {
                        if (pool.id === LOOKUP['bring-your-own-talent']) {
                            return TalentPool.make({
                                ...pool,
                                talent_users_count: pool.talent_users_count + 1
                            })
                        }
                        return TalentPool.make(pool);
                    });
                })

                queryClient.invalidateQueries({ predicate: ({ queryKey }) => queryKey?.[0] === 'fetchTalentPoolDetail' })

                TB.toast("Invitation sent!", { type: 'success' });
            },
            onError: () => {
                TB.showServerErrorToast();
            }
        }
    )
    const handleUpload = async (model) => {
        await inviteByEmailMutation.mutateAsync(model)
        setIsModalOpen(false)
        setFormModel({})
    }

    // const handleUpload = async (e) => {
    //     e.preventDefault();
    //     await inviteByEmailMutation.mutateAsync(formModel)
    //     setIsModalOpen(false)
    //     setFormModel({})
    // }

    const handleCancel = () => {
        setIsModalOpen(false);
        inviteByEmailMutation.reset();
    }


    return (
        <>
            <button
                type="button"
                className={TB.mapClass("btn p-3 duration-300 whitespace-nowrap", {
                    "bg-black text-white": useDarkTheme,
                    "bg-white hover:bg-black hover:text-white": !useDarkTheme
                })}
                onClick={() => setIsModalOpen(true)}
            >
                Invite Someone
            </button>


            <Modal
                destroyOnClose
                open={isModalOpen}
                onCancel={handleCancel}
                closable={false}
                maskClosable
                title={null}
                footer={null}
                bodyStyle={{ padding: 0 }}
                className="w-[700px]"
                zIndex={100}
            >

                <div className="bg-white invite-by-email-modal">
                    {/* <div className="h-14 bg-primary flex items-center pl-4">
                        <button
                            type="button"
                            onClick={() => setIsModalOpen(false)}
                            className="h-[22px]"
                        >
                            <div className="close-icon" />
                        </button>
                    </div> */}

                    <div className="px-8 py-6 flex flex-col gap-4">

                        <div className="flex justify-between gap-4">
                            <p className="text-xl font-semibold">Invite Someone</p>

                            <button
                                type="button"
                                onClick={() => setIsModalOpen(false)}
                                className="h-[22px]"
                            >
                                <div className="close-icon" />
                            </button>
                        </div>

                        <p className="text-sm">
                            Fill the following inputs to invite someone to your talent pools.
                        </p>

                        <Form
                            title={null}
                            subtitle={null}
                            submitButton={false}
                            onSubmit={handleUpload}
                            background="transparent"
                            model={formModel}
                            onChange={setFormModel}
                            fields={[]}
                            novalidate
                        // isDisabled={isUpdating || props.isDisabled}
                        >

                            <div className="flex gap-6 pb-3 w-full">
                                <FormInputComponent
                                    fieldName="first_name"
                                    type="antd-input"
                                    // label={false}
                                    value={formModel.first_name}
                                    className="w-full"
                                >
                                    <Input
                                        type="text"
                                        name="first_name"
                                        // placeholder="First name"
                                        required
                                        validationErrors={{
                                            isDefaultRequiredValue: "The first name field is required."
                                        }}
                                    />
                                </FormInputComponent>

                                <FormInputComponent
                                    fieldName="last_name"
                                    type="antd-input"
                                    // label={false}
                                    value={formModel.last_name}
                                    className="w-full"
                                >
                                    <Input
                                        type="text"
                                        name="last_name"
                                        // placeholder="Last name"
                                        required
                                        validationErrors={{
                                            isDefaultRequiredValue: "The last name field is required."
                                        }}
                                    />
                                </FormInputComponent>

                            </div>

                            <FormInputComponent
                                type="email"
                                name="email"
                                label="Email"
                                // placeholder="Enter email address"
                                required
                            />


                            {inviteByEmailMutation.error && (
                                <div className="bg-wripplePrimaryPaleRed p-4">
                                    <p className="text-white">{inviteByEmailMutation.error.message}</p>
                                </div>
                            )}


                            <div className="flex flex-row gap-3 justify-end mt-[50px]">

                                <button
                                    type="button"
                                    className="btn btn-outline-dark w[100px]"
                                    // disabled={isUpdating}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={!formModel.first_name || !formModel.last_name || !formModel.email || inviteByEmailMutation?.isLoading}
                                >
                                    Invite
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default InviteByEmailModal;